import api from "@/api";
import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
const activeRowModal: any = ref({});
const addDesicion: any = ref({});
import { notify } from "@kyvg/vue3-notification";
import $ from "jquery";
import { Roles } from "../enums/Roles";
let lastUpdated: any = {
  id: null,
};
const data = {
  readyToUseFilters: {},
  filter: {
    searchResult: true,
    filterVersion: true,
    ignoreSaveFilter: true,
    dateFilter: false,
    searchText: true,
    textSearch: true,
    title: "Review Filter",
    pageName: "ProposedUniqueBlockPage",
    genre: "proposedUniqueBlock",
    filters: [
      {
        title: "rolePolicy",
        apiEquivalent: "rolePolicy",
        type: "select",
        param: "label",
        hideOnRole: Roles.GroupAdmin,
        data: [
          {
            label: "WorkStation",
            id: "WorkStation",
          },
          {
            label: "Basic Server",
            id: "Basic Server",
          },
          {
            label: "Server Lock Down",
            id: "Server Lock Down",
          },
        ],
      },
      {
        title: "mode",
        apiEquivalent: "mode",
        type: "select",
        param: "label",
        vmodel: null,
        data: [
          {
            label: "Enforcing",
            id: "1",
          },
          {
            label: "Discovery",
            id: "2",
          },
        ],
      },
      {
        title: "action",
        apiEquivalent: "action",
        type: "select",
        param: "label",
        vmodel: null,
        data: [
          {
            label: "Blocked Process",
            id: "Blocked Process",
          },
          {
            label: "Blocked File Write",
            id: "Blocked File Write",
          },
          {
            label: "Blocked File Read",
            id: "Blocked File Read",
          },
          {
            label: "Blocked File Extension Write",
            id: "Blocked File Extension Write",
          },
          {
            label: "Blocked File Extension Read",
            id: "Blocked File Extension Read",
          },
          {
            label: "Blocked Registry Write",
            id: "Blocked Registry Write",
          },
          {
            label: "Blocked Registry Read",
            id: "Blocked Registry Read",
          },
          {
            label: "Blocked Code Load",
            id: "Blocked Code Load",
          },
          {
            label: "Blocked Memory Write",
            id: "Blocked Memory Write",
          },
          {
            label: "Blocked Memory Read",
            id: "Blocked Memory Read",
          },
        ],
      },
      {
        title: "status",
        type: "select",
        apiEquivalent: "status",
        vmodel: null,
        param: "label",
        disabled: false,
        data: [
          {
            label: "Not Decided",
            id: "0",
          },
          {
            label: "Decision Drafted",
            id: "1",
          },
          {
            label: "Decision Applied",
            id: "2",
          },
          {
            label: "Decision Published",
            id: "3",
          },
        ],
      },
      {
        title: "decision",
        apiEquivalent: "decision",
        type: "select",
        param: "label",
        vmodel: null,
        disabled: false,
        data: [
          {
            label: "Modify Policy",
            id: "1",
          },
          {
            label: "Keep Enforcing",
            id: "2",
          },
        ],
      },
      {
        title: "Time Range",
        type: "date",
        param: "range",
        apiEquivalent: "range",
        hidden: true,
        vmodel: null,
      },
      {
        title: "Actor",
        apiEquivalent: "actor",
        type: "wordstyped",
        param: "actor",
        disabled: true,
      },
      {
        title: "Target",
        apiEquivalent: "target",
        type: "wordstyped",
        param: "target",
        disabled: true,
      },
    ],
  },
  models: {
    addDescion: {
      id: "",
      eventId: "",
      rolePolicy: "",
      uniqueEventHash: "",
      decisionOptionId: "",
      mode: "",
      modeId: "",
      action: "",
      actor: "",
      target: "",
      effectedComputerCount: "",
      totalComputerCount: "",
      eventCount: "",
      percentageComputer: "",
      policyFileVersion: "",
      lastStatusChange: "",
      groupGuid: "",
      decision: "",
      decisionId: "",
      decisionStatusId: "",
      option: "",
      decisionStatus: "",
      scope: "",
    },
  },
  header: {
    policyNavigation: true,
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        // {
        //   label: "rolePolicy",
        //   field: "rolePolicy",
        //   sortable: true,
        // },
        {
          label: "mode",
          field: "modeName",
          sortable: false,
        },

        {
          label: "action",
          field: "action",
          sortable: true,
          display: function (row: any) {
            let label = "";
            if (row.action.indexOf("Allow") > -1) {
              label = '<span class="green-indicator"></span>';
            } else {
              label = '<span class="red-indicator"></span>';
            }
            return (
              "<div class='d-flex align-items-center'> " +
              label +
              " <span>" +
              row.action.replaceAll("Blocked", "").replaceAll("Allowed", "") +
              "</span> </div>"
            );
          },
        },
        {
          label: "actor",
          field: "actor",
          sortable: true,
          truncate: {
            position: "middle",
            first: 0,
            last: 0,
            tableShow: function (row: any) {
              const fullPath = row.actor || "";
              if (!fullPath) {
                return `<div class="d-flex align-items-center">N/A</div>`;
              }
              const fileName = fullPath.split(/[\\|/]/).pop() || fullPath;
              return `<span>${fileName}</span>`;
            },
          },
        },
        {
          label: "target",
          field: "target",
          sortable: true,
          truncate: {
            position: "middle",
            first: 6,
            last: 6,
          },
          display: function (row: any) {
            if(row.target === "") {
              return `<div class="d-flex align-items-center">N/A</div>`;
            }
            else{
              return `<div class="d-flex align-items-center">${row.target}</div>`;
            }
          }
        },
        {
          label: "effectedTotalComp",
          field: "effectedTotalComp",
          sortable: false,
          display: function (row: any) {
            let labelClass = "warning";
            if (row.percentageComputer < 50) {
              labelClass = "success";
            } else if (
              row.percentageComputer > 50 &&
              row.percentageComputer < 70
            ) {
              labelClass = "warning";
            } else {
              labelClass = "danger";
            }
            return `<div class="d-flex align-items-center">${row.effectedComputerCount} / ${row.totalComputerCount} <span class="ag-badge badge badge-${labelClass}">${row.percentageComputer} %</span></div>`;
          },
        },
        {
          label: "eventcount",
          onclick: (row: any, evt: any) => {
            if (evt.target.type === undefined) {
              console.log("undefined");
            } else {
              store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, row);
              store.dispatch(
                GeneralActionTypes.SET_COMPKEY,
                store.getters.compKey + 1
              );
            }
          },
          display: function (row: any) {
            if (row.eventCount) {
              return `<a
              data-toggle="modal"
              data-target="#exampleModalCenterSecondary"
              href="#"
              class="name-btn"
              >${row.eventCount}</a
            >`;
            } else {
              return 0;
            }
          },
        },
        {
          label: "lastStatusChange",
          field: "lastStatusChange",
          sortable: false,
          hidden: function (prt: any) {
            return !prt.$route.query.searchResults;
          },
        },
        {
          label: "status",
          field: "status",
          sortable: false,
          hidden: function (prt: any) {
            return !prt.$route.query.searchResults;
          },
          display: function (row: any) {
            if (row.decisionStatusId) {
              return row.decisionStatusName;
            } else {
              return "Not Decided";
            }
          },
        },
        {
          label: "decisionOption",
          field: "decisionOptionName",
          sortable: false,
          hidden: function (prt: any) {
            return !prt.$route.query.searchResults;
          },
        },
        {
          label: "",
          field: "edit",
          display: function (row: any) {
            row.notEditable = true;
            addDesicion.value.data = row;
          },
          components: [
            {
              component: "tableExpandComponent",
            },
          ],
        },
      ],
      dateFilter: false,
      rows: [],
      total: 0,
      sortable: {
        order: "",
        sort: "asc",
      },
      page: 1,
      pageSize: 5,
      isLoading: false,
      readyToUseFilters: {
        policyFileVersion: "",
        policyFileVersionLimit: "",
        startDate: "",
        endDate: "",
      },
     fetchTable: async (options: any, type: any) => {
        let filters;
        if (options.currentSearchFilters) {
          filters = { 
            ...options.currentSearchFilters, 
            page: options.page, 
            limit: options.pageSize 
          };
        } else {
          filters = { ...data.readyToUseFilters, page: options.page, limit: options.pageSize };
        }
        const body: any = { filters, options };
        if (options.readyToUseFilters) {
          for (const [key, value] of Object.entries(options.readyToUseFilters)) {
            if(key == 'page' && value) {
              body.options['page'] = value;
              options.readyToUseFilters.page = null;
            }else if(value) {
              body.filters[key] = value;
            }
          }
        }
        if(type === 'interval') {
          delete body.filters['policyFileVersion'];
          delete body.filters['policyFileVersionLimit'];
        }
        store.dispatch(GeneralActionTypes.GET_PROPOSED_UNIQUE_BLOCKS, body);
     },
    },
  },
  modals: [
    {
      id: "exampleModalCenter",
      action: {
        label: "Save",
        function: async function (arg: any) {
          const body = {
            id: data.models.addDescion.id,
            eventId: data.models.addDescion.eventId,
            rolePolicy: data.models.addDescion.rolePolicy,
            uniqueEventHash: data.models.addDescion.uniqueEventHash,
            decisionOptionId: data.models.addDescion.decisionOptionId,
            mode: data.models.addDescion.mode,
            modeId: data.models.addDescion.modeId,
            action: data.models.addDescion.action,
            actor: data.models.addDescion.actor,
            target: data.models.addDescion.target,
            effectedComputerCount: data.models.addDescion.effectedComputerCount,
            totalComputerCount: data.models.addDescion.totalComputerCount,
            eventCount: data.models.addDescion.eventCount,
            percentageComputer: data.models.addDescion.percentageComputer,
            policyFileVersion: data.models.addDescion.policyFileVersion,
            lastStatusChange: data.models.addDescion.lastStatusChange,
            groupGuid: data.models.addDescion.groupGuid,
            decisionStatus: data.models.addDescion.decisionStatus,
            decisionStatusId: data.models.addDescion.decisionStatusId,
            decisionId: data.models.addDescion.decisionId,
            option: data.models.addDescion.option,
            decision: data.models.addDescion.decision,
            scope: data.models.addDescion.scope,
          };
          await store.dispatch(
            GeneralActionTypes.CREATE_UNIQUE_BLOCK_REVIEW,
            body
          );
          $($("#exampleModalCenter")[0]).removeClass("show");
          $($("#exampleModalCenter")[0]).css("display", "none");
          $("body").removeClass("modal-open");
          $(".modal-backdrop").remove();
          notify({
            title: "Saved",
            type: "success",
            duration: 4000,
          });
          store.dispatch(
            GeneralActionTypes.SET_COMPKEY,
            store.getters.compKey + 1
          );
          lastUpdated = data.models.addDescion;
          let txt = "";
          if (lastUpdated.decisionStatusId === 1) {
            txt = "Drafted";
          } else if (lastUpdated.decisionStatusId === 2) {
            txt = "Applied";
          } else if (lastUpdated.decisionStatusId === 3) {
            txt = "Published";
          }
          $("#" + lastUpdated.id + " a").text(txt);
          $("#" + lastUpdated.id + " a").addClass("decision-text");
        },
      },
      display: function (row: any) {
        activeRowModal.value.data = row;
      },
      cancel: {
        label: "Close",
      },
      active: 0,
      items: [
        {
          title: "addDesicion",
          component: "ag-add-desicion",
          options: { activeRowModal, addDesicion },
        },
      ],
    },
    {
      id: "exampleModalCenterSecondary",
      action: {
        label: "Save",
        function: function (arg: any) {
          alert(JSON.stringify(arg));
        },
      },
      cancel: {
        label: "Close",
      },
      items: [
        {
          title: "individualEvents",
          component: "ag-event-list",
          options: {},
          filters: () => {
            return data.readyToUseFilters;
          },
        },
        {
          title: "overallview",
          component: "ag-overall",
        },
        {
          title: "processtree",
          component: "ag-processtree",
        },
        {
          title: "computer",
          component: "ag-computer",
        },
        {
          title: "hashdetails",
          component: "ag-hashdetail",
        },
        {
          title: "hashxmldetail",
          component: "ag-hashxmldetail",
        },
        {
          title: "policy",
          component: "ag-event-policy",
        },
      ],
    },
  ],
};

export default data;
